const SITE_ID = Number(window.AMZ_ENV.REACT_APP_SITE_ID)
const SUBDOMAIN = window.AMZ_ENV.REACT_APP_SUBDOMAIN
export { SITE_ID, SUBDOMAIN }